import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, CopyIcon } from 'assets/icons';
import { ReferralService } from 'services';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Referrals extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Fecha',
			'Nombre',
			'Monto',
			'Estatus'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		copied: false,
		link: ''
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Referidos',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await ReferralService.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.referrals?.rows || [],
			last_page: res.referrals?.count || 0,
			link: res.link || ''
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	getColor = (item: any) => {
		switch(item.status) {
			case Constants.REFERRAL_STATUS.PENDING:
				return Colors.yellow;
			break;

			case Constants.REFERRAL_STATUS.PAID:
				return Colors.green_light;
			break;
		}
	}

	render() {
		return (
			<div id="client-referrals">
				<div className="row row-filter">
					<div className="col-md-4">
						<Input
							value={ this.state.form.search }
							name="search"
							placeholder="Buscar"
							searchLeft={ true }
							className="input-table"
							onSubmit={ () => this.load() }
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-1">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
				</div>

				<div className="row">
					<div className="col-md-6"></div>
					<div className="col-md-6">
						<div className="copy-display">
							<div className="container-copy">
								<p>{ this.state.link }</p>
								<CopyToClipboard text={ this.state.link } onCopy={ () => {
									this.setState({ copied: true },() => {
										setTimeout(() => {
											this.setState({ copied: false });
										},1500);
									});
								} }>
									<img src={ CopyIcon } />
								</CopyToClipboard>
							</div>

							{
								this.state.copied && (
									<p className="copied">Copiado al portapapeles</p>
								)
							}
						</div>
					</div>
				</div>

				<Table title="Referidos" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i.created_at).format('DD/MM/YYYY') }</td>
								<td>{ i.user_referral?.name } { i.user_referral?.lastname }</td>
								<td>{ Globals.formatMiles(i.amount) }</td>
								<td className="status" style={{ color: this.getColor(i) }}>{ i.status_text }</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Referrals);